// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card_functions ion-icon {
  font-size: 26px;
}

.alert_bar {
  background: #dbb49f;
  display: inline-flex;
  justify-content: space-between;
  width: 100%;
  padding: 20px 15px;
  box-sizing: border-box;
  border-bottom: 2px solid #bba599;
  color: #fff;
  cursor: pointer;
}
.alert_bar ul {
  list-style: none;
  padding: 0;
  color: #fff;
  font-size: 12px;
}
.alert_bar p {
  width: 80%;
}
.alert_bar h3 {
  font-size: 14px;
  font-weight: bold;
}
.alert_bar ion-icon {
  font-size: 27px;
  margin-top: 45px;
}

.content_wrap {
  padding-left: 15px;
  padding-right: 15px;
}
.content_wrap .likedTxt {
  font-size: 12px;
  cursor: pointer;
}
.content_wrap .coreDesc {
  margin-top: 5px;
  font-size: 14px;
}
.content_wrap .coreDesc b {
  cursor: pointer;
}
.content_wrap .coreDesc .micro_txt {
  font-size: 12px;
  display: block;
  margin-top: 5px;
  color: #959595;
}
.content_wrap .about_wrapper ion-avatar {
  height: 40px;
  width: 40px;
  margin-right: 10px;
  margin-left: 15px;
}
.content_wrap .about_wrapper .artist_name {
  margin: 0;
  padding: 0;
  font-size: 16px;
  margin-top: 3px;
  font-weight: bold;
  color: #eab3a3;
  cursor: pointer;
}
.content_wrap .about_wrapper h4 {
  margin: 0;
  font-size: 10px;
  color: #c1a299;
}
.content_wrap .about_wrapper .stars {
  margin: 0;
}
.content_wrap .about_wrapper .stars ion-icon {
  font-size: 16px;
}
.content_wrap .about_wrapper ion-list {
  margin-top: 10px;
}

.section_block {
  margin-top: 20px;
  margin-bottom: 20px;
}

.subTitle {
  margin-left: 15px;
  margin-bottom: 15px;
  font-weight: 800;
  color: #d2b094;
}

.grey {
  color: grey !important;
}

ion-item {
  cursor: pointer;
}

.inline {
  display: inline-flex;
}

.small_space {
  height: 20px;
  width: 100%;
}

.full_buttons {
  display: inline-flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
  grid-gap: 10px;
}
.full_buttons .full_button {
  border-radius: 4px;
  background: rgba(226, 147, 81, 0.6117647059);
  width: 31%;
  display: inline-flex;
  justify-content: space-between;
  margin-bottom: 20px;
  margin-top: 10px;
  padding: 8px;
  padding-left: 10px;
  white-space: nowrap;
  cursor: pointer;
  color: rgb(254, 249, 242);
  text-transform: uppercase;
  font-size: 12px;
  font-weight: 900;
}
.full_buttons .full_button ion-icon {
  font-size: 21px;
  display: block;
}
.full_buttons .full_button label {
  display: block;
  padding-top: 3.5px;
  width: 100%;
  cursor: pointer;
}

.inline_subtitle h3 {
  margin-right: 15px;
  margin-top: 25px;
}
.inline_subtitle .secure_block {
  display: flex;
  border: 1px solid #edba92;
  width: -moz-fit-content;
  width: fit-content;
  padding: 12px;
  color: #edba92;
  margin-left: auto;
  grid-gap: 10px;
  border-radius: 4px;
  position: absolute;
  right: 30px;
  cursor: pointer;
}
.inline_subtitle .secure_block ion-icon {
  font-size: 16px;
}
.inline_subtitle .secure_block h3 {
  font-size: 14px;
  text-transform: uppercase;
  font-weight: 900;
  margin: 0;
}

.card_wrapper {
  display: inline-flex;
  justify-content: space-between;
  overflow-x: scroll;
  overflow-y: hidden;
  width: 100%;
}

.dull {
  opacity: 0.4;
}

ion-back-button {
  margin-right: 10px;
  color: #cdcbcb;
}

ion-content {
  --background: #fef9f2 !important;
}

ion-toolbar {
  --background: #fef9f2;
}

ion-footer {
  padding: 0;
  margin: 0;
  background: #f9f9f9;
  border-top: 1px solid #dbdbdb;
  position: sticky;
  bottom: 0;
  min-height: 45px;
}

.top_footer_bar {
  padding-bottom: 4px;
  background: rgba(255, 243, 229, 0.9490196078);
  border-bottom: 2px dashed #baa599;
  min-height: 45px;
}

.empty_sec_txt p {
  font-size: 12px;
  margin: 15px 21px;
  color: #cebaaf;
  background: #fff3e7;
  padding: 10px;
  border-radius: 4px;
}

.additonal_tags {
  margin: 10px 0;
}

.straight_items {
  margin-top: 15px;
}
.straight_items .item {
  width: 95%;
  display: inline-flex;
  background: #fff2e6;
  color: #bba599;
  justify-content: space-between;
  padding: 14px 26px;
  margin-left: 7px;
  cursor: pointer;
}
.straight_items .item ion-label {
  font-weight: bold;
}

.promo_badge {
  width: 40px;
  height: 40px;
  float: right;
  margin-top: -60px;
  margin-right: 20px;
  object-fit: contain;
  mix-blend-mode: multiply;
}`, "",{"version":3,"sources":["webpack://./src/app/listing/listing.page.scss"],"names":[],"mappings":"AACI;EACI,eAAA;AAAR;;AAIA;EACI,mBAAA;EACA,oBAAA;EACA,8BAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;EAEA,gCAAA;EACA,WAAA;EACA,eAAA;AAFJ;AAII;EACI,gBAAA;EACA,UAAA;EACA,WAAA;EACA,eAAA;AAFR;AAKI;EACI,UAAA;AAHR;AAMI;EACI,eAAA;EACA,iBAAA;AAJR;AAOI;EACI,eAAA;EACA,gBAAA;AALR;;AASA;EACI,kBAAA;EACA,mBAAA;AANJ;AAQI;EACI,eAAA;EACA,eAAA;AANR;AASI;EACI,eAAA;EACA,eAAA;AAPR;AASQ;EACI,eAAA;AAPZ;AAUQ;EACI,eAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;AARZ;AAaQ;EACI,YAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;AAXZ;AAcQ;EACI,SAAA;EACA,UAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AAZZ;AAeQ;EACI,SAAA;EACA,eAAA;EACA,cAAA;AAbZ;AAeQ;EACI,SAAA;AAbZ;AAeY;EACI,eAAA;AAbhB;AAiBQ;EACI,gBAAA;AAfZ;;AAoBA;EACI,gBAAA;EACA,mBAAA;AAjBJ;;AAoBA;EACI,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;AAjBJ;;AAoBA;EACI,sBAAA;AAjBJ;;AAoBA;EACI,eAAA;AAjBJ;;AAoBA;EACI,oBAAA;AAjBJ;;AAoBA;EACI,YAAA;EACA,WAAA;AAjBJ;;AAoBA;EACI,oBAAA;EACA,eAAA;EACA,uBAAA;EACA,WAAA;EACA,cAAA;AAjBJ;AAmBI;EACI,kBAAA;EACA,4CAAA;EAEA,UAAA;EACA,oBAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EAEA,yBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;AAnBR;AAqBQ;EACI,eAAA;EACA,cAAA;AAnBZ;AAsBQ;EACI,cAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;AApBZ;;AA0BI;EACI,kBAAA;EACA,gBAAA;AAvBR;AA0BI;EACI,aAAA;EACA,yBAAA;EACA,uBAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;AAxBR;AA0BQ;EACI,eAAA;AAxBZ;AA2BQ;EACI,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,SAAA;AAzBZ;;AA8BA;EACI,oBAAA;EACA,8BAAA;EAEA,kBAAA;EACA,kBAAA;EAEA,WAAA;AA7BJ;;AAgCA;EACI,YAAA;AA7BJ;;AAgCA;EACI,kBAAA;EACA,cAAA;AA7BJ;;AAgCA;EACI,gCAAA;AA7BJ;;AAgCA;EACI,qBAAA;AA7BJ;;AAgCA;EACI,UAAA;EACA,SAAA;EACA,mBAAA;EACA,6BAAA;EACA,gBAAA;EACA,SAAA;EACA,gBAAA;AA7BJ;;AAgCA;EACI,mBAAA;EACA,6CAAA;EACA,iCAAA;EACA,gBAAA;AA7BJ;;AAgCA;EACI,eAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;AA7BJ;;AAgCA;EACI,cAAA;AA7BJ;;AAgCA;EACI,gBAAA;AA7BJ;AA+BI;EACI,UAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,8BAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AA7BR;AA+BQ;EACI,iBAAA;AA7BZ;;AAkCA;EACI,WAAA;EACA,YAAA;EAEA,YAAA;EACA,iBAAA;EACA,kBAAA;EAEA,mBAAA;EACA,wBAAA;AAjCJ","sourcesContent":[".card_functions {\n    ion-icon {\n        font-size: 26px;\n    }\n}\n\n.alert_bar {\n    background: #dbb49f;\n    display: inline-flex;\n    justify-content: space-between;\n    width: 100%;\n    padding: 20px 15px;\n    box-sizing: border-box;\n    //box-shadow: inset 0px -5px 20px 0px #2a2a2a;\n    border-bottom: 2px solid #bba599;\n    color: #fff;\n    cursor: pointer;\n\n    ul {\n        list-style: none;\n        padding: 0;\n        color: #fff;\n        font-size: 12px;\n    }\n\n    p {\n        width: 80%;\n    }\n\n    h3 {\n        font-size: 14px;\n        font-weight: bold;\n    }\n\n    ion-icon {\n        font-size: 27px;\n        margin-top: 45px;\n    }\n}\n\n.content_wrap {\n    padding-left: 15px;\n    padding-right: 15px;\n\n    .likedTxt {\n        font-size: 12px;\n        cursor: pointer;\n    }\n\n    .coreDesc {\n        margin-top: 5px;\n        font-size: 14px;\n\n        b {\n            cursor: pointer;\n        }\n\n        .micro_txt {\n            font-size: 12px;\n            display: block;\n            margin-top: 5px;\n            color: #959595;\n        }\n    }\n\n    .about_wrapper {\n        ion-avatar {\n            height: 40px;\n            width: 40px;\n            margin-right: 10px;\n            margin-left: 15px;\n        }\n\n        .artist_name {\n            margin: 0;\n            padding: 0;\n            font-size: 16px;\n            margin-top: 3px;\n            font-weight: bold;\n            color: #eab3a3;\n            cursor: pointer;\n        }\n\n        h4 {\n            margin: 0;\n            font-size: 10px;\n            color: #c1a299;\n        }\n        .stars {\n            margin: 0;\n\n            ion-icon {\n                font-size: 16px;\n            }\n        }\n\n        ion-list {\n            margin-top: 10px;\n        }\n    }\n}\n\n.section_block {\n    margin-top: 20px;\n    margin-bottom: 20px;\n}\n\n.subTitle {\n    margin-left: 15px;\n    margin-bottom: 15px;\n    font-weight: 800;\n    color: #d2b094;\n}\n\n.grey {\n    color: grey !important;\n}\n\nion-item {\n    cursor: pointer;\n}\n\n.inline {\n    display: inline-flex;\n}\n\n.small_space {\n    height: 20px;\n    width: 100%;\n}\n\n.full_buttons {\n    display: inline-flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    width: 100%;\n    grid-gap: 10px;\n\n    .full_button {\n        border-radius: 4px;\n        background: #e293519c;\n\n        width: 31%;\n        display: inline-flex;\n        justify-content: space-between;\n        margin-bottom: 20px;\n        margin-top: 10px;\n        padding: 8px;\n        padding-left: 10px;\n        white-space: nowrap;\n        cursor: pointer;\n\n        color: rgb(254 249 242);\n        text-transform: uppercase;\n        font-size: 12px;\n        font-weight: 900;\n\n        ion-icon {\n            font-size: 21px;\n            display: block;\n        }\n\n        label {\n            display: block;\n            padding-top: 3.5px;\n            width: 100%;\n            cursor: pointer;\n        }\n    }\n}\n\n.inline_subtitle {\n    h3 {\n        margin-right: 15px;\n        margin-top: 25px;\n    }\n\n    .secure_block {\n        display: flex;\n        border: 1px solid #edba92;\n        width: -moz-fit-content;\n        width: fit-content;\n        padding: 12px;\n        color: #edba92;\n        margin-left: auto;\n        grid-gap: 10px;\n        border-radius: 4px;\n        position: absolute;\n        right: 30px;\n        cursor: pointer;\n\n        ion-icon {\n            font-size: 16px;\n        }\n\n        h3 {\n            font-size: 14px;\n            text-transform: uppercase;\n            font-weight: 900;\n            margin: 0;\n        }\n    }\n}\n\n.card_wrapper {\n    display: inline-flex;\n    justify-content: space-between;\n\n    overflow-x: scroll;\n    overflow-y: hidden;\n\n    width: 100%;\n}\n\n.dull {\n    opacity: 0.4;\n}\n\nion-back-button {\n    margin-right: 10px;\n    color: #cdcbcb;\n}\n\nion-content {\n    --background: #fef9f2 !important;\n}\n\nion-toolbar {\n    --background: #fef9f2;\n}\n\nion-footer {\n    padding: 0;\n    margin: 0;\n    background: #f9f9f9;\n    border-top: 1px solid #dbdbdb;\n    position: sticky;\n    bottom: 0;\n    min-height: 45px;\n}\n\n.top_footer_bar {\n    padding-bottom: 4px;\n    background: #fff3e5f2;\n    border-bottom: 2px dashed #baa599;\n    min-height: 45px;\n}\n\n.empty_sec_txt p {\n    font-size: 12px;\n    margin: 15px 21px;\n    color: #cebaaf;\n    background: #fff3e7;\n    padding: 10px;\n    border-radius: 4px;\n}\n\n.additonal_tags {\n    margin: 10px 0;\n}\n\n.straight_items {\n    margin-top: 15px;\n\n    .item {\n        width: 95%;\n        display: inline-flex;\n        background: #fff2e6;\n        color: #bba599;\n        justify-content: space-between;\n        padding: 14px 26px;\n        margin-left: 7px;\n        cursor: pointer;\n\n        ion-label {\n            font-weight: bold;\n        }\n    }\n}\n\n.promo_badge {\n    width: 40px;\n    height: 40px;\n\n    float: right;\n    margin-top: -60px;\n    margin-right: 20px;\n\n    object-fit: contain;\n    mix-blend-mode: multiply;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
